import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NavService {

constructor(private http:HttpClient) { }


Get():Observable<any>{
  return this.http.get(environment.BaseUrl+ "Daro/Nav").pipe(
    map(data=>{
      return data as any
    })
  )
}

GetNotice():Observable<Array<any>>{
  return this.http.get(environment.BaseUrl+ "Daro/Nav/GetNotice").pipe(
    map(data=>{
      return data as Array<any>
    })
  )
}

GetUser(id:number,customer:boolean):Observable<Array<Nav_Interface>>{
  return this.http.get(environment.BaseUrl+ "Daro/Nav/GetUser?id="+id+"&customer="+customer).pipe(
    map(data=>{
      return data as Array<Nav_Interface>
    })
  )
}

CheckValidPage(id:number):Observable<any>{
  const menuId = id;
  return this.http.get(environment.BaseUrl+ "Daro/Nav/CheckValidPage?id="+menuId).pipe(
    map(data=>{
      return data as any
    })
  )
}

}
